import { ApplicationView, useController } from '@aha-app/mvc';
import React, { useState } from 'react';
import VotingSessionController from './controllers/VotingSessionController';
import type { RecordId } from '../../../types';
import classNames from 'classnames';
import styles from './VotingSession.module.css';
import SlideOutPanel from './SlideOutPanel';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';
import { pluralize } from '@aha-app/aha-shared';
import fistToFiveIcons from './fistToFiveIcons';

const FistToFiveResult: React.FC<{
  widget: VotingSessionWidget;
  value: number;
  voterIds: Array<RecordId>;
  winner: boolean;
}> = ({ widget, value, voterIds, winner }) => {
  const [detailsShown, setDetailsShown] = useState(false);
  const controller = useController(VotingSessionController);

  if (!widget) return null;

  const voteCount = voterIds.length;
  const voters = voterIds.map(id => controller.getResolvedUser(id));

  return (
    <li>
      <div
        className={classNames(
          'px-2 py-3',
          styles.votingResultEntry,
          styles.votingResultAction,
          {
            'side-panel__hover-background': !detailsShown,
          }
        )}
        onClick={() => {
          setDetailsShown(!detailsShown);
        }}
      >
        <div className='flex-col gap-2'>
          <div className='flex-row flex-row--align-center flex-row--justify-space-between'>
            <div className='flex-row flex-row--align-center gap-2'>
              <span className={classNames('h-500')}>
                {fistToFiveIcons[value]}
              </span>
              <div
                className={classNames('flex-row flex-row--align-center gap-2')}
              >
                <p className='mb-0'>
                  <span className='h-500 font-500'>{voteCount}</span>&nbsp;
                  <span className='t-200 color-tertiary'>
                    {pluralize(voteCount, 'vote')}
                  </span>
                </p>
              </div>
              {winner && (
                <aha-pill
                  color='var(--theme-alert-success-background)'
                  text-color='var(--theme-alert-success-text)'
                  border-shape='round'
                >
                  Most popular
                </aha-pill>
              )}
            </div>
            <div>
              <i
                className={`fa-regular fa-chevron-${
                  detailsShown ? 'up' : 'down'
                }`}
              />
            </div>
          </div>
        </div>
      </div>
      <SlideOutPanel direction='vertical' open={detailsShown}>
        <ol className='unstyled pt-3'>
          {voters.map((voter, i) => (
            <li
              key={`voter-${i}`}
              className='ml-6 mr-4 p-2 side-panel__hover-background'
            >
              <div className='flex-row flex-row--align-center gap-2'>
                <span className={styles.voteCountVoter}>{voter}</span>
              </div>
            </li>
          ))}
        </ol>
        <div className='text-right pt-2 pb-7 mr-4'>
          <aha-button
            kind='ghost'
            onClick={() => {
              setDetailsShown(false);
            }}
          >
            <span className='t-200 color-tertiary'>Hide details</span>
          </aha-button>
        </div>
      </SlideOutPanel>
    </li>
  );
};

export default ApplicationView(FistToFiveResult);
